import React, { useState } from "react";
import { Menu, X } from "lucide-react";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="header">
      <div className="header-container">
        <div className="logo">
          <span className="logo-text">Laboratorio Secreto</span>
        </div>
        
        <nav className="nav-desktop">
          <a href="#programs" className="nav-link">Programas</a>
          <a href="#methodology" className="nav-link">Metodología</a>
          <a href="#testimonials" className="nav-link">Testimonios</a>
          <a href="#pricing" className="nav-link">Precios</a>
        </nav>

        <button className="btn-primary">Únete al Lab</button>

        <button 
          className="menu-toggle"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {isMenuOpen && (
        <nav className="nav-mobile">
          <a href="#programs" className="nav-link-mobile" onClick={() => setIsMenuOpen(false)}>
            Programas
          </a>
          <a href="#methodology" className="nav-link-mobile" onClick={() => setIsMenuOpen(false)}>
            Metodología
          </a>
          <a href="#testimonials" className="nav-link-mobile" onClick={() => setIsMenuOpen(false)}>
            Testimonios
          </a>
          <a href="#pricing" className="nav-link-mobile" onClick={() => setIsMenuOpen(false)}>
            Precios
          </a>
          
           <a href="https://wa.me/525572269158" className="btn-primary-mobile" target="_blank"
          rel="noopener noreferrer" onClick={() => { window.fbq?.("track", "Contact");
            console.log("Click WhatsApp Hero");
            }}
            >
              Únete al Lab
          </a>
        
        </nav>
      )}
    </header>
  );
};

export default Header;